import { ModalDialog } from '@/scripts/interactive-defer/modal-dialog'
import {
	getAttributeOrThrow,
	qsRequired,
	setOverflowStatus,
	trapFocus,
} from '@/scripts/core/global'
import {
	getActiveOrAccessibilityElement,
	getSectionHTMLForResource,
} from '@/scripts/core/cart-functions'

export class DynamicQuizStub extends ModalDialog {
	static override htmlSelector = 'dynamic-quiz-stub'
	sourceUrl: string
	openers?: NodeListOf<HTMLButtonElement>
	dynamicContent: HTMLElement
	titleText?: string
	preloaded: boolean = false

	constructor() {
		super()
		this.sourceUrl = getAttributeOrThrow('data-quiz-url', this)
		this.dynamicContent = qsRequired('[data-dynamic-content]', this)
	}

	async preload() {
		if (this.preloaded) return
		await this.getQuizContent()
		if (this.preloaded) return // in case the 'click' loader beats the preloader
		this.preloaded = true
	}

	async initializePopup(opener?: HTMLButtonElement) {
		await this.getQuizContent()
		this.openedBy = opener
		document.body.classList.add('overflow-hidden')
		const dialog = qsRequired('[role="dialog"]', this)
		dialog.setAttribute('open', '')
		this.setAttribute('open', '')
		this.show(opener ?? getActiveOrAccessibilityElement())
		setOverflowStatus(this.dynamicContent)
		void window.Ucoast.mediaManager.loadAllInContainer(this.dynamicContent)
	}

	async getQuizContent() {
		if (this.preloaded) return
		const html = await getSectionHTMLForResource(
			this.sourceUrl,
			'dynamic-quiz'
		)
		if (!html) {
			throw new Error(`html not found for sourceUrl: ${this.sourceUrl}`)
		}
		if (this.preloaded) return // in case the preloader has finished in between this request completing
		this.dynamicContent.innerHTML = html
		this.preloaded = true
	}

	async getQuizResult(url: string, title: string) {
		this.preloaded = false
		this.titleText = title
		const html = await getSectionHTMLForResource(url, 'dynamic-quiz-result')
		if (!html) {
			throw new Error(`html not found for sourceUrl: ${this.sourceUrl}`)
		}
		this.dynamicContent.innerHTML = html
		void window.Ucoast.mediaManager.loadAllInContainer(this.dynamicContent)
		const handle = url.replace('/pages/quiz-result/', '')
		const formData = new FormData()
		formData.append('attributes[_quiz_result]', handle)
		fetch(window.routes.cart_update_url, {
			method: 'POST',
			body: formData,
		})
			.then((response) => response.text())
			.catch((error) =>
				console.error('Error logging quiz result:', error)
			)
	}

	override getHtmlSelector() {
		return DynamicQuizStub.htmlSelector
	}

	override connectedCallback() {}

	override show(opener: HTMLElement) {
		this.removeAttribute('style')
		window.setTimeout(() => {
			this.openedBy = opener
			document.body.classList.add('overflow-hidden')
			this.setAttribute('open', '')
			trapFocus(this, qsRequired('[data-question="1"] input', this))
		}, 2)
	}

	override hide() {
		super.hide()
	}
}
